import PropTypes from 'prop-types';
import { createContext, useEffect, useReducer } from 'react';
// utils
import axios from '../utils/axios';
import { isValidToken, setSession } from '../utils/jwt';

// ----------------------------------------------------------------------

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user,
    };
  },
  LOGIN: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null,
  }),
  REGISTER: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
};

const reducer = (state, action) => (handlers[action.type] ? handlers[action.type](state, action) : state);

const AuthContext = createContext({
  ...initialState,
  method: 'jwt',
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  register: () => Promise.resolve(),
});

// ----------------------------------------------------------------------

AuthProvider.propTypes = {
  children: PropTypes.node,
};

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = window.localStorage.getItem('accessToken');
        const refreshToken = window.localStorage.getItem('refreshToken');

        if (accessToken && isValidToken(accessToken) && refreshToken && isValidToken(refreshToken)) {
          setSession(accessToken, refreshToken);

          const response = await axios.get('/users/me');
          const user = response.data;

          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: true,
              user,
            },
          });
        } else {
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: false,
              user: null,
            },
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    };

    initialize();
  }, []);

  const login = async (email, password) => {
    const clientInformation = {
      client_id: "1",
      client_secret: "76e6ce9a7e10d26ac315b76e9fa8783f83922291db48ffd7264b8a17c22a89c1"
    }

    const response = await axios.post('/users/login', {
      email,
      password,
      ...clientInformation
    });
    const { accessToken, refreshToken } = response.data;

    window.localStorage.removeItem('activeAccount');
    window.localStorage.removeItem('serviceAlias');

    setSession(accessToken, refreshToken);

    const responseUser = await axios.get('/users/me');
    const user = responseUser.data;
    const {id} = responseUser.data;

    window.localStorage.setItem('id', id);
    window.localStorage.setItem('email', email);


    const {accounts} = responseUser.data;
    if (accounts && Array.isArray(accounts) && accounts.length > 0){
    const defaultAccount = accounts.find((account) => account.default === true)
    console.log(defaultAccount);
    window.localStorage.setItem('activeAccount', defaultAccount.serviceNumber);
    window.localStorage.setItem('serviceAlias', defaultAccount.serviceAlias);
    };


    dispatch({
      type: 'LOGIN',
      payload: {
        user,
      },
    });
  };

  const register = async (email, password, firstName, lastName, phone) => {
    const response = await axios.post('/users', {
      email,
      password,
      firstName,
      lastName,
      phone,
    });
    const user  = response.data;

    // window.localStorage.setItem('accessToken', accessToken);
    dispatch({
      type: 'REGISTER',
      payload: {
        user,
      },
    });
  };

  const logout = async () => {
    setSession(null);
    dispatch({ type: 'LOGOUT' });
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'jwt',
        login,
        logout,
        register,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
